import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getOrgUnitMembers as getOrgUnitMembersSchema } from '../gqlSchemes/getOrgUnitMembers';

interface IHookProps {
  name?: string;
  roleTypes?: string[];
  careTeamIds?: string[];
}

export const useOrgUnitMembers = ({ name, roleTypes, careTeamIds }: IHookProps) => {

  const [orgUnitMembers, setOrgUnitMembers] = useState([]);
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    hasNextPage: true,
    perPage: 20,
  });
  const [getOrgUnitMembers, { data, loading }] = useLazyQuery(
    getOrgUnitMembersSchema
  );

  useEffect(() => {
    const filterObj = {
      name,
      roleTypes,
      ...(careTeamIds && careTeamIds.length > 0 && { careTeamIds }),
    };
    
    getOrgUnitMembers({
      fetchPolicy: 'no-cache',
      variables: {
        page: 0,
        perPage: 20,
        filter: filterObj,
      },
      onCompleted: (res) => {
        setPageInfo(res?.user?.dashboard?.practitionerPagination?.pageInfo);
        setOrgUnitMembers(res?.user?.dashboard?.practitionerPagination?.items);
      },
    });
  }, [name, JSON.stringify(careTeamIds)]);


  // API now handles care team filtering, no client-side filtering needed

  const fetchMoreData = (name: string) => {
    if (pageInfo && !pageInfo?.hasNextPage) {
      return;
    }
    
    getOrgUnitMembers({
      fetchPolicy: 'no-cache',
      variables: {
        page: pageInfo.page + 1,
        perPage: 20,
        filter: {
          name,
          roleTypes,
          ...(careTeamIds && careTeamIds.length > 0 && { careTeamIds }),
        },
      },
      onCompleted: (res) => {
        const newItems = res?.user?.dashboard?.practitionerPagination?.items || [];
        const updatedMembers = orgUnitMembers.concat(newItems);
        
        setPageInfo(res?.user?.dashboard?.practitionerPagination?.pageInfo);
        setOrgUnitMembers(updatedMembers);
      },
    });
  };

  return {
    orgUnitMembers,
    fetchMoreData,
    orgUnitsLoading: loading,
  };
};
